var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.56667 9.30669C1.82667 9.68002 2.28667 9.89335 2.81333 9.89335H5.54667C5.72667 9.89335 5.89334 9.96669 6.00667 10.1C6.12667 10.2334 6.17334 10.42 6.14667 10.6134L5.80667 12.8C5.66 13.4534 6.09333 14.1867 6.74667 14.4067C7.35333 14.6334 8.06667 14.3267 8.35333 13.8934L11.16 9.71335L11.24 9.58002V3.68669L11.14 3.58669L9.02667 1.95335C8.74667 1.67335 8.11333 1.52002 7.66667 1.52002H5.06667C4.17333 1.52002 3.27333 2.19335 3.07333 3.01335L1.43333 8.00669C1.26667 8.48002 1.31333 8.94669 1.56667 9.30669Z",
    fill: "#402E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5267 11.74H13.2133C14.2467 11.74 14.6667 11.34 14.6667 10.3533V3.65333C14.6667 2.66666 14.2467 2.26666 13.2133 2.26666H12.5267C11.4933 2.26666 11.0733 2.66666 11.0733 3.65333V10.36C11.0733 11.34 11.4933 11.74 12.5267 11.74Z",
    fill: "#402E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedDislike);
export default __webpack_public_path__ + "static/media/highlighted-dislike.697b30db72f1ce186304be6bc4080ac7.svg";
export { ForwardRef as ReactComponent };